import { memo } from 'react'

import { LinkOffOutlined } from '@mui/icons-material'

import { useDispatch, useSelector } from '@tabeeb/store'
import { ConfirmationDialog, IconButton, Subheader3, Tooltip, useDialogState } from '@collaborate-health/uikit'
import { getContentId } from '@tabeeb/shared/content/selectors'
import { useFormTitleFormatter } from '@tabeeb/modules/shared/utils/text'

import { detachForm } from '../../actions'
import { ContentForm } from '../../types'
import { getIsAddFormButtonVisible, getIsDetachButtonDisabled } from '../../selectors'
import { FormsListItemPaper } from './FormsListItem.styles'

export interface FormsListItemProps {
  form: ContentForm
  onSelect: (formId: number) => void
}

const FormsListItem: React.FC<FormsListItemProps> = ({ form, onSelect }) => {
  const dispatch = useDispatch()

  const { f } = useFormTitleFormatter()

  const [detachConfirmationDialogOpen, onOpenDetachConfirmationDialog, onCloseDetachConfirmationDialog] =
    useDialogState()

  const contentId = useSelector(getContentId)

  const showDetachButton = useSelector(getIsAddFormButtonVisible)
  const disableDetachButton = useSelector((state) => getIsDetachButtonDisabled(state, { form }))

  return (
    <>
      <FormsListItemPaper key={form.Id} variant='outlined' onClick={() => onSelect(form.Id)}>
        <Subheader3 key={form.Id} flex={1} noWrap>
          {form.Name}
        </Subheader3>

        {showDetachButton && (
          <Tooltip text='Detach'>
            <span>
              <IconButton
                disabled={disableDetachButton}
                color='error'
                onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()

                  onOpenDetachConfirmationDialog()
                }}
              >
                <LinkOffOutlined />
              </IconButton>
            </span>
          </Tooltip>
        )}
      </FormsListItemPaper>

      <ConfirmationDialog
        isOpen={detachConfirmationDialogOpen}
        title={f('Are you sure you want to detach this form?')}
        dialogMessage={f('This form will be detached. You can attach it again later if needed')}
        onCloseDialog={onCloseDetachConfirmationDialog}
        submitButtonText='Detach'
        submitButtonColor='error'
        onSubmit={() => {
          dispatch(detachForm.request({ contentId, formId: form.FormId }))
          onCloseDetachConfirmationDialog()
        }}
      />
    </>
  )
}

export default memo(FormsListItem)

